import {UnstyledLink, useRemoveAllToasts} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const SoftSuccessNotificationContent: React.FC<{
  headline: string;
  cta?: {
    label: string;
    linkTarget: {
      url: string;
      external: boolean;
    };
  };
}> = ({headline, cta}) => {
  const removeToast = useRemoveAllToasts();

  return (
    <Wrapper>
      {headline}
      {cta && (
        <StyledUnstyledLink
          to={cta.linkTarget.url}
          onClick={() => removeToast()}
        >
          {cta.label}
        </StyledUnstyledLink>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

const StyledUnstyledLink = styled(UnstyledLink)`
  border: 1px solid black;
  border-radius: 4px;
  padding: 8px;
  flex-shrink: 0;
`;
